import React, { useMemo } from 'react';
import block from 'bem-cn';
import Input from 'components/Input';
import Button from 'components/Button';
import Paginator from 'components/Paginator';
import DateRangeFilter from './DateRangeFilter/DateRangeFilter';
import { useWithdrawalHistory } from '../../model/withdrawalHistory/useWithdrawalHistory';
import WithdrawalHistoryItem from './WithdrawalHistoryItem/WithdrawalHistoryItem';
import CheckBox from 'components/CheckBox';
import { useSelector } from 'react-redux';
import './WithdrawalHistory.scss';

const b = block('withdrawal-history');

const WithdrawalHistory = () => {
  const locale = useSelector(state => state.locale.locale);
  const { input, output } = useWithdrawalHistory();
  const {
    values,
    handleFromChange,
    handleToChange,
    handleStatusChange,
    handlePageChange,
    handleWithdrawalHistorySubmit,
    handleLoginChange,
    handleAmountChange,
    handleUserIdChange,
    dateRanges,
  } = input;

  const items = useMemo(
    () => output.items.map(item => <WithdrawalHistoryItem key={item.id} item={item} />),
    [output.items],
  );

  return (
    <div className={b()}>
      <div className={b('title')}>{locale['/withdrawal-history']}</div>

      <form className={b('filters-wrapper')} onSubmit={handleWithdrawalHistorySubmit}>
        <div className={b('filters')}>
          <div className={b('top-filters')}>
            <div className={b('status-filter-block')}>
              <label className={b('filter-label')}>{locale.operation}</label>

              <div className={b('checkboxes')}>
                <label className={b('checkbox')}>
                  <div className={b('checkbox-input')}>
                    <CheckBox name="0" checked={values.status.includes(0)} onChange={() => handleStatusChange(0)} />
                  </div>
                  <span className={b('checkbox-text')}>{locale.created}</span>
                </label>

                <label className={b('checkbox')}>
                  <div className={b('checkbox-input')}>
                    <CheckBox name="1" checked={values.status.includes(1)} onChange={() => handleStatusChange(1)} />
                  </div>
                  <span className={b('checkbox-text')}>{locale.completed}</span>
                </label>

                <label className={b('checkbox')}>
                  <div className={b('checkbox-input')}>
                    <CheckBox name="2" checked={values.status.includes(2)} onChange={() => handleStatusChange(2)} />
                  </div>
                  <span className={b('checkbox-text')}>{locale.rejected}</span>
                </label>
              </div>
            </div>
          </div>

          <div className={b('bottom-filters')}>
            <div className={b('filter-col')}>
              <label className={b('filter-label')}>{locale.withdrawalAmount}</label>
              <Input
                value={values.amount}
                onChange={e => handleAmountChange(e.currentTarget.value)}
                placeholder={locale.withdrawalAmount}
              />
            </div>
            <div className={b('filter-col')}>
              <label className={b('filter-label')}>{locale.userId}</label>
              <Input
                value={values.userId}
                onChange={e => handleUserIdChange(e.currentTarget.value)}
                placeholder={locale.userId}
              />
            </div>
            <div className={b('filter-col')}>
              <label className={b('filter-label')}>{locale.userLogin}</label>
              <Input
                value={values.login}
                onChange={e => handleLoginChange(e.currentTarget.value)}
                placeholder={locale.userLogin}
              />
            </div>
            <DateRangeFilter
              startDate={dateRanges.from}
              endDate={dateRanges.to}
              setStartDate={handleFromChange}
              setEndDate={handleToChange}
            />
            <div className={b('filter-col', { button: true })}>
              <Button type="submit" text={locale.show} />
            </div>
          </div>
        </div>
      </form>

      <article className={b('content')}>
        <div className={b('items')}>{items}</div>
        <div className={b('paginator')}>
          <Paginator currentPage={values.page} pageCount={output.pages} onPageClick={handlePageChange} />
        </div>
      </article>
    </div>
  );
};

export default WithdrawalHistory;
